import React from 'react';
import {useAppDispatch} from '../../hooks/redux';

import {
    Button as AlchemyButton,
} from '@amzn/alchemy-components-react'

import { showCreateBookmark } from '../../slices/bookmarkModalSlice';
import i18n from '../../i18n';
import currentStage from "../../stages.const";

interface CreateBookmarkButtonProps {}

export default function(props: CreateBookmarkButtonProps) {
    const dispatch = useAppDispatch()

    function handleNewBookmarkClick() {
        dispatch(showCreateBookmark())
    }

    return (
        <AlchemyButton variant="action" onClick={handleNewBookmarkClick}>{i18n.t('button:new-bookmark')}</AlchemyButton>
    )
}
